
import { BinderPromo } from "./promo.model"
import { BinderPeople } from "./sig-request.model"

interface assembly {
  categoryName: string,
  description: string,
  quantity: number,
  total: number,
  showPrice: boolean,
  type: string,
  CategoryID: number,
  PrintOrder: number
}

export interface masterJson {
  BinderID: number,
  warranty: string,
  assemblies: assembly[],
  higharcOptions?: JSONOption[],
  shortDate: string,
  higharch: boolean,
  combinedNames: string,
  date: string,
  primaryName: string,
  designValues: {
    exposure: string,
    frost: number,
    jurisdiction: string,
    parcel: string,
    seismic: number,
    powerCo: string,
    powerLocation: string,
    waterSupply: string,
    septicDesign: string,
    sewerType: string,
    wetlands: string,
    snowLoad: {
      ground: number,
      roof: number,
    },
    soil: number,
    windLoad: {
      ASD: number,
      ULT: number
    }
  },
  project: {
    address: string,
    city: string,
    consultantName: string,
    name: string,
    state: string,
    zip: number
  },
  financialValues: {
    contractBalance: number,
    credit: {
      amount: number,
      title: string
    },
    designServiceFee: {
      price: number,
      designFeeFirst: number,
      designeFeeRemainder: number
      standardDesign: number,
      addEngineering: number
    },
    dispersalBalance: number,
    draws: ParsedDraw[],
    dueLessTax: number,
    engineeringFee: number,
    lender: {
      address: string,
      city: string,
      depositeDate: string,
      disableClosing: false,
      fax: string,
      isLender: boolean,
      name: string,
      officer: string,
      phone: string,
      preapprovedAmount: number,
      state: string,
    },
    optionsTotal: number,
    planPrice: number,
    processingFee: number,
    projectCost: number,
    showTravel: boolean,
    subtotal: number,
    taxSavingsTable: Reduction[],
    taxValues: {
      code: number,
      name: string,
      rate: string,
      totalAmount: number,
      finalTax: number
    },
    travelRate: number,
    travelTitle: string,
  },
  mailing: {
    mailing_address: string,
    address: string,
    city: string,
    state: string,
    zip: string
  },
  notes: [],
  oItems: {
    items: {
      Item: string,
      Priceint: number,
    }[],
    itemTotal: number,
    property: number,
    grandTotal: number,
  },
  office: {
    ConstructionCo: string,
    LDate: Date | null,
    LNumber: string,
    LocationAddress: string,
    LocationCity: string,
    LocationName: string,
    LocationState: string,
    LocationZip: number,
    daysToFinish: number,
    daysToStart: number
  },
  peopleList: BinderPeople[],
  plan: {
    planName: string,
    orientation: string,
  }
}

export interface JSONOption {
  optionTitle: string,
  optionDescription: string,
  optionPrice: number
}

export interface ParsedDraw {
  Event: string,
  Percentage: string,
  amount: number,
  Total: string
}

export interface Reduction {
  item: string,
  total: number,
  reduction: string,
  taxSaving: boolean
}

export class CalcTotals {
options: {optionSubtotal: number, engineeringTotal: number, solarTotal: number, optionTotal: number};
tax: number;
subtotal: number;
contractTotal: number;
travelTotal: number;
planPrice: number;
balance: number;
dispersalBalance: number;
dueLessTax: number;
processingFee: number;
taxError?: {
  showError: boolean,
  showDialog: boolean,
  message: string
};
design: {
  designTotal: number;
  initialDesign: number;
  firstFee: number;
  remainder: number
};
promos: {
  promoTotal: number;
  binderPromos: BinderPromo[];
};
savings: {
  reductions:
  Reduction[],
    total: number;

};

constructor() {
  this.design = {
    designTotal: 0,
    initialDesign: 0,
    firstFee: 0,
    remainder: 0
  };
  this.savings = {
    reductions: [],
    total: 0
  };
  this.promos = {
    promoTotal: 0,
    binderPromos: []
  };
  this.tax = 0;
  this.processingFee = 0;
  this.contractTotal = 0;
  this.travelTotal = 0;
  this.planPrice = 0;
  this.dueLessTax = 0;
  this.subtotal = 0;
  this.contractTotal = 0;
  this.balance = 0;
  this.dispersalBalance = 0;
  this.options = {
    optionSubtotal: 0,
    engineeringTotal: 0,
    solarTotal: 0,
    optionTotal: 0
  };
}
};
